import {Component, Input} from '@angular/core';
import {JaarruimtegegevensComponent} from './jaarruimtegegevens/jaarruimtegegevens.component';
import {LijfrentePremiesComponent} from './lijfrente-premies/lijfrente-premies.component';

@Component({
  selector: 'snelstart-venture-fiscaal-feature-lijfrente',
  templateUrl: './lijfrente.component.html',
  styleUrls: ['./lijfrente.component.scss'],
  imports: [
    JaarruimtegegevensComponent,
    LijfrentePremiesComponent
  ]
})
export class LijfrenteComponent  {

    @Input() public id!: string;

}
